import { registerPlugin } from '@capacitor/core';

export interface FileSavePlugin {
  saveFile(options: {
    filename: string;
    mimeType: string;
    base64Data: string;
  }): Promise<{ uri: string }>;
}

const FileSave = registerPlugin<FileSavePlugin>('FileSave');

export default FileSave;